module.exports = __webpack_public_path__ + "static/img/role.4d8f8c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/bn/role.png
// module id = dNkY
// module chunks = 7